import Eyebrow from "./Eyebrow";
import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "Dank seiner hilfsbereiten und freundlichen Art war Andreas im Team äusserst geschätzt und trug zu einer konstruktiven Zusammenarbeit bei. Er überblickt auch schwierige Zusammenhänge, erkennt das Wesentliche und findet schnell gute Lösungen.",
  },
  {
    quote:
      "Herr Fischinger verfügt über ein äusserst umfassendes und fundiertes Fachwissen, das er stets sehr sicher und erfolgreich einsetzt. Er arbeitet äusserst effizient, selbständig und sorgfältig und überzeugt in seinen Tätigkeiten immer in qualitativer und quantitativer Hinsicht.",
  },
  {
    quote:
      "Er zeigt grosse Eigeninitiative und überzeugt durch seinen hohen Einsatz, auch über die übliche Arbeitszeit hinaus. Besonders hervorzuheben sind seine Belastbarkeit und Ausdauer bei starkem Arbeitsanfall – auch höchstem Zeitdruck war er stets hervorragend gewachsen.",
  },
];

const SocialProof = () => (
  <section id="referenzen" className="border-b py-16 sm:py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 space-y-10 lg:space-y-14">

      <div className="space-y-2">
        <Eyebrow>Referenzen</Eyebrow>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight">
          Was ehemalige Arbeitgeber sagen
        </h2>
        <p className="text-muted-foreground text-base max-w-2xl leading-relaxed pt-1">
          Auszüge aus meinen Arbeitszeugnissen.
        </p>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="testimonials-grid">
        {TESTIMONIALS.map((t, i) => (
          <div
            key={i}
            data-testid={`testimonial-card-${i}`}
            className="rounded-2xl border bg-card p-6 shadow-sm flex flex-col gap-4"
          >
            <Quote className="size-6 text-accent shrink-0" strokeWidth={1.5} fill="currentColor" fillOpacity={0.12} />
            <p className="text-sm text-foreground/90 leading-relaxed flex-1">
              „{t.quote}"
            </p>
            <p className="text-xs text-muted-foreground pt-1 border-t">
              Aus einem Arbeitszeugnis
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SocialProof;
